import { render, staticRenderFns } from "./dailyMealPrice.vue?vue&type=template&id=3710d839&scoped=true&"
import script from "./dailyMealPrice.vue?vue&type=script&lang=js&"
export * from "./dailyMealPrice.vue?vue&type=script&lang=js&"
import style0 from "./dailyMealPrice.vue?vue&type=style&index=0&id=3710d839&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3710d839",
  null
  
)

export default component.exports